import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from 'components/PublicBreadcrumb';
import { ROUTES } from 'config/constants';
import Wrapper from 'components/Wrapper';
import './ProductConfiguration.scss';
import withLoading from 'components/WithLoading';
import ParamConfig from 'components/Configuration/ParamConfig';
import Result from 'components/Configuration/Result';
import Loading from 'components/Product/Loading';

class ProductConfigurationScreen extends Component {
    static propTypes = {
        data: PropTypes.any,
        slug: PropTypes.string,
        history: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.state = {
            steps: [
                { name: 'Products', path: ROUTES.HOME },
                { name: 'category', path: ROUTES.HOME },
                { name: 'Product Details', path: ROUTES.PUBLICPRODUCT(this.props.slug) },
                { name: 'Product Configuration', path: '' }
            ],
            params: [],
            configs: null,
            results: [],
            dataLoading: false
        };
    }

    componentDidMount() {
        const { data } = this.props;

        if (data) {
            const tmp = [];

            for (const item of data.variations) {
                item.selectedAttribute = [];

                if (item.attributes) {
                    tmp.push(item);
                }
            }

            const attrs = [];

            for (const item of data.variations) {
                if (item.attributes && item.attributes.length !== 0) {
                    for (const att of item.attributes) {
                        const prevItem = attrs.findIndex(e => e.name === att.name);

                        if (prevItem > -1) {
                            // add to that attributes
                            const prevValue = attrs[prevItem].value.findIndex(e => e === att.value[0]);

                            if (prevValue < 0) {
                                // value was not add before
                                attrs[prevItem].value.push(att.value[0]);
                            }
                        } else {
                            // add itself
                            attrs.push({
                                name: att.name,
                                value: [...att.value]
                            });
                        }
                    }
                }
            }

            this.setState({
                configs: attrs,
                results: tmp,
                steps:
                    [
                        { name: 'Products', path: ROUTES.HOME },
                        { name: data.category.name, path: ROUTES.CATEGORY_DETAILS(data.category.slug) },
                        { name: data.name, path: ROUTES.PUBLICPRODUCT(data.slug) }
                    ]
            });
        }
    }

    getparams = ({ name, param }) => {
        const tmp = this.state.params;

        const findValue = tmp.find(e => e.name === name);

        if (!findValue) {
        // name isn't in the filters so add it
            tmp.push({ name, value: [param] });
        } else {
            const index = tmp.indexOf(findValue);
            const paramValues = tmp[index].value;
            const findParam = (paramValues).find(e => e === param);

            if (!findParam) {
                // param isn't in the filters so add it
                paramValues.push(param);
            } else {
                // param is in the filters so remove it
                const paramIndex = paramValues.indexOf(findParam);

                if (paramValues.length > 1) {
                    paramValues.splice(paramIndex, 1);
                } else {
                    tmp.splice(index, 1);
                }
            }
        }

        this.setState({ params: tmp });

        if (this.state.configs.length < 5) {
            this.findVariations(tmp);
        }
    }

    findVariations = params => {
        const { data } = this.props;
        const tmp = [];

        if (params.length !== 0) {
            for (var param of params) {
                for (var variation of data.variations) {
                    if (!variation.attributes) {
                        break;
                    }

                    // eslint-disable-next-line no-loop-func
                    const findAttrName = variation.attributes.find(attr => attr.name === param.name && param.value.find(e => e === attr.value[0]));

                    if (findAttrName) {
                        // eslint-disable-next-line no-loop-func
                        const preVariation = tmp.find(e => e.id === variation.id);

                        if (!preVariation) {
                            // variation wasn't in the results
                            variation.selectedAttribute = [findAttrName];
                            tmp.push(variation);
                        } else {
                            // get variation Selected attributes and check if this attributes was in selected before or not
                            const index = tmp.indexOf(variation);
                            const selectedValues = tmp[index].selectedAttribute;

                            const choosenBefore = selectedValues.find(e => e.name === findAttrName.name);

                            if (!choosenBefore) {
                                selectedValues.push(findAttrName);
                            }
                        }
                    }
                }
            }
        } else {
            for (const item of data.variations) {
                item.selectedAttribute = [];

                if (item.attributes) {
                    tmp.push(item);
                }
            }
        }

        const sortIt = tmp.sort((a, b) =>
            (a.selectedAttribute.length < b.selectedAttribute.length)
                ? 1
                : (
                    (a.selectedAttribute.length === b.selectedAttribute.length)
                        ? 1 : -1
                ));

        this.setState({ results: sortIt }, () => { this.fakeLoading(); });
    }

    fakeLoading = () => {
        this.setState({ dataLoading: true }, () => {
            setTimeout(() => {
                this.setState({ dataLoading: false });
            }, 700);
        });
    }

    render() {
        const { steps, params, configs, results, dataLoading } = this.state;
        const { data, history } = this.props;

        return (
            <div className='config'>
                {dataLoading && <Loading />}
                <div className='config--header'>
                    <Wrapper>
                        <Breadcrumb steps={steps} activeStep='Product Details' />
                    </Wrapper>
                </div>
                <div className='config--content'>
                    {configs &&
                        <ParamConfig configs={configs} onClick={e => this.getparams(e)} params={params}
                            onSave={() => this.findVariations(params)} onCancel={() => { this.setState({ params: [] }, () => this.findVariations([])); }}/>
                    }
                </div>
                <div className='config--result'>
                    {data && results.map((item, i) =>
                        <Result item={item} key={i} type={i % 2 === 0 ? 'odd' : 'even'}
                            data={data} history={history}/>
                    )}
                </div>
            </div>
        );
    }
}

export default withLoading(ProductConfigurationScreen);
